import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { getPriceOfMenuCart, MenuCartItem, SelectedIngredientOption, SelectedMenuItems } from "../models/fullMenuCart";
import { FullMenuPageData } from "../profilePage/maintainSpecificRestaurant/upsertFullMenuHelpers";
import { formatMoney } from "../services/strings/formatters";

export const MenuItemDetails = ({ item, menuData, soldOutItems }: { item: MenuCartItem, menuData: FullMenuPageData, soldOutItems?: MenuCartItem[] }) => {

    const optionsToShow = (it: SelectedMenuItems) => {
        const visibleSelectedOptions: SelectedIngredientOption[] = []
        it.selectedOptions.map((selOpt, oIdx) => {
            if (selOpt.quantity > 0) {
                visibleSelectedOptions.push({ ...selOpt })
            }
        })
        return visibleSelectedOptions;
    }

    return (
        <ListItemText
            primary={
                <Typography variant="h5" style={{ whiteSpace: 'pre-line' }}>
                    {item.name}
                </Typography>
            }
            secondary={<Box display="flex" flexDirection="column" gap={0.5} mt={1}>
                {/* Total */}
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                    <strong>Total:</strong>{' '}
                    {formatMoney(getPriceOfMenuCart([item], menuData) / 100)}
                </Typography>

                {/* Items */}
                {item.items.map((it, idx) => (
                    <Box key={it.id ?? idx} sx={{ pl: 1, mb: 0.25 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                            <strong>Sub item:</strong> {it.name}
                        </Typography>

                        {/* Selected variants as a simple bulleted list */}
                        <List
                            component="ul"
                            sx={{
                                listStyleType: 'disc',
                                pl: 2,    // indent bullets
                                mb: 0,
                                mt: 0,
                            }}
                        >
                            <Typography component="span" variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                                <strong>Customizations</strong>
                            </Typography>
                            {it.selectedVariants.map((selVar, vIdx) => {
                                const price = !item.comboVariant ? selVar.price : selVar.comboPrice;
                                return (
                                    <ListItem
                                        key={selVar.id ?? vIdx}
                                        component="li"
                                        sx={{
                                            display: 'list-item',
                                            py: 0,    // remove vertical padding
                                            my: 0,    // remove vertical margin
                                        }}
                                    >
                                        <Typography component="span" variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                                            <strong>Selected:</strong> {selVar.name}
                                            {price > 0 ? ` (+ ${formatMoney(price / 100)})` : ''}
                                        </Typography>
                                    </ListItem>
                                );
                            })}
                        </List>

                        {/* Selected options (if any) */}
                        {it.selectedOptions && optionsToShow(it).length > 0 && (
                            <List component="ul" sx={{ listStyleType: 'disc', pl: 2, mb: 0, mt: 0 }}>
                                <Typography component="span" variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                                    <strong>Extras</strong>
                                </Typography>
                                {optionsToShow(it).map((selOpt, oIdx) => {
                                    if (selOpt.quantity > 0) {
                                        return <ListItem
                                            key={selOpt.option?.id ?? oIdx}
                                            component="li"
                                            sx={{ display: 'list-item', py: 0, my: 0 }}
                                        >
                                            <Typography component="span" variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                                                {selOpt.option.name} ( + {formatMoney(selOpt.option.price / 100)})
                                            </Typography>
                                        </ListItem>
                                    }
                                })}
                            </List>
                        )}
                    </Box>
                ))}

                {/* Category for the chosen combo variant (if present) */}
                {item.comboVariant && (() => {
                    const foundCat = menuData.menu.categories.find((cat) =>
                        cat.items.some((ci) => ci.comboVariants?.some((cv) => cv.id === item.comboVariant!.id))
                    );
                    return foundCat ? (
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                            <strong>Category:</strong> {foundCat.name}
                        </Typography>
                    ) : null;
                })()}

                {/* TODO NEED TO FINALISES COLLECTION TIMES */}
                {/* <DateRangePill startDate={new Date()} endDate={new Date(cart.collectBy)} /> */}
            </Box>

            }
        />
    );
};